var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-download-5006210") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-download-5006210",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.4999975,5.29289 L5.4999975,0.5 C5.4999975,0.22386 5.27614,0 4.9999975,0 C4.72386,0 4.4999975,0.22386 4.4999975,0.5 L4.4999975,5.29289 L2.85355,3.64645 C2.65829,3.45118 2.34171,3.45118 2.14645,3.64645 C1.95118,3.84171 1.95118,4.15829 2.14645,4.35355 L4.9999975,7.2071 L7.8536,4.35355 C8.0488,4.15829 8.0488,3.84171 7.8536,3.64645 C7.6583,3.45119 7.3417,3.45119 7.1464,3.64645 L5.4999975,5.29289 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,6.5 C1.27614,6.5 1.5,6.72386 1.5,7 L1.5,7.8 C1.5,8.1866 1.8134,8.5 2.2,8.5 L7.8,8.5 C8.1866,8.5 8.5,8.1866 8.5,7.8 L8.5,7 C8.5,6.72386 8.7239,6.5 9,6.5 C9.2761,6.5 9.5,6.72386 9.5,7 L9.5,7.8 C9.5,8.7389 8.7389,9.5 7.8,9.5 L2.2,9.5 C1.26112,9.5 0.5,8.7389 0.5,7.8 L0.5,7 C0.5,6.72386 0.72386,6.5 1,6.5 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e87c8cc4ac6965a31f671414a7addc62.svg";
export { ForwardRef as ReactComponent };